import { endpoints } from './apiConfig';
import { registerType, loginType } from './types';
import { USER_TOKEN, USER, COUNTRIES } from './apiConfig';
import { GuideRequest, Guide } from '@/features/guides/guidesSlice';
import axiosInstance from '@/axiosInstance';
import { setUserAction, updateTokensInLocalStorage } from '@//helpers';
import { store } from '@/lib/store';
import { fetchBalanceSuccess } from "@/features/tokens/tokensSlice";

const saveUser = async (response, navigate) => {
    if (response.status === 200 || response.status === 201) {
        console.log(response, navigate)
        localStorage.setItem(USER, JSON.stringify(response.data.user));
        localStorage.setItem(USER_TOKEN, response.data.token);
        console.log('api service')
        setUserAction(response.data.user);
        if (navigate) {
            navigate('/profile');
        }
    }
}

export const register = async (userData: registerType, navigate) => {
    try {
        const response = await axiosInstance.post(endpoints.register, userData);
        console.log(response)
        await saveUser(response, navigate);
    } catch (error) {
        console.error('Error registering user:', error);
        throw error;
    }
};

export const login = async (credentials: loginType, navigate) => {
    try {
        const response = await axiosInstance.post(endpoints.login, credentials);
        await saveUser(response, navigate);
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};

export const user = async () => {
    try {
        const res = await axiosInstance.get(endpoints.user);
        console.log(res)
        if (res.status === 200) {
            if (res.data && res.data.tokens !== undefined) {
                store.dispatch(fetchBalanceSuccess(res.data.tokens));
                updateTokensInLocalStorage(res.data.tokens);
            }
            return res.data;
        }
    } catch (error) {
        console.error('Error fetching user data:', error);
        throw error;
    }
};

export const updateUser = async (userData: { name: string; email: string }) => {
    try {
        const response = await axiosInstance.put(endpoints.user, userData);
        if (response.status === 200 || response.status === 201) {
            const updatedUserData = response.data.user;
            localStorage.setItem(USER, JSON.stringify(updatedUserData));
            console.log('api service 2')
            setUserAction(updatedUserData);

            if (updatedUserData.tokens !== undefined) {
                store.dispatch(fetchBalanceSuccess(updatedUserData.tokens));
                updateTokensInLocalStorage(updatedUserData.tokens);
            }

            return response.data;
        }
    } catch (error) {
        console.error('Error updating user:', error);
        throw error;
    }
};

export const guide = async (id: number | string): Promise<Guide | null> => {
    try {
        const res = await axiosInstance.get(`${endpoints.guides}/${id}`);
        if (res.status === 200) {
            return res.data;
        }
        return null
    } catch (error) {
        console.error('Error fetching guide:', error);
        throw error;
    }
};

export const createGuide = async (data: GuideRequest): Promise<Guide | null> => {
    try {
        const res = await axiosInstance.post(endpoints.guides, data);
        if (res.status === 200 || res.status === 201) {
            return res.data;
        }
        return null
    } catch (error) {
        console.error('Error creating guide:', error);
        throw error;
    }
};

export const options = async () => {
    try {
        const res = await axiosInstance.get(endpoints.options);
        if (res.status === 200) {
            return res.data;
        }
        return null
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};

export const guides = async (page: number = 1, isPublic: boolean = true, filters = '') => {
    try {
        const url = isPublic ? endpoints.publicGuides : endpoints.guides;
        const filtersParam = filters ? `&${filters}` : '';
        const res = await axiosInstance.get(`${url}?page=${page}${filtersParam}`);
        if (res.status === 200) {
            return res.data;
        }
        return null
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};

export const requestPasswordReset = async (email: string) => {
    try {
        const response = await axiosInstance.post(endpoints.forgotPassword, { email });
        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error requesting password reset:', error);
        throw error;
    }
};

export const resetPassword = async (token: string, password: string, password_confirmation: string) => {
    try {
        const response = await axiosInstance.post(endpoints.resetPassword, {
            token,
            password,
            password_confirmation
        });
        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error resetting password:', error);
        throw error;
    }
};

export const googleLogin = async (token: string, navigate) => {
    try {
        const response = await axiosInstance.post(endpoints.googleLogin, { token });
        await saveUser(response, navigate);
    } catch (error) {
        console.error('Error with Google login:', error);
        throw error;
    }
};

export const googleRegister = async (token: string, navigate) => {
    try {
        const response = await axiosInstance.post(endpoints.googleRegister, { token, "terms": 1 });
        await saveUser(response, navigate);
    } catch (error) {
        console.error('Error with Google register:', error);
        throw error;
    }
};

export const getPaymentPackages = async () => {
    try {
        const response = await axiosInstance.get(endpoints.paymentPackages);
        if (response.status === 200 || response.status === 201) {
            return response.data.packages;
        }
    } catch (error) {
        console.error('Error fetching payment packages:', error);
    }

    return [
        {
            "id": "starter",
            "name": "Starter Package",
            "description": "5 tokens for $2",
            "tokens": 5,
            "price": 2,
            "price_cents": 200,
            "stripe_price_id": "price_starter_tokens"
        },
        {
            "id": "popular",
            "name": "Popular Package",
            "description": "15 tokens for $5",
            "tokens": 15,
            "price": 5,
            "price_cents": 500,
            "stripe_price_id": "price_popular_tokens"
        },
        {
            "id": "premium",
            "name": "Premium Package",
            "description": "50 tokens for $15",
            "tokens": 50,
            "price": 15,
            "price_cents": 1500,
            "stripe_price_id": "price_premium_tokens"
        }
    ];
};

export const createPaymentIntent = async (packageId: string) => {
    try {
        const response = await axiosInstance.post(endpoints.paymentIntent, {
            package: packageId
        });
        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error creating payment intent:', error);
        throw error;
    }
};

export const processPayment = async (paymentMethodId: string, packageId: string) => {
    try {
        const response = await axiosInstance.post(endpoints.paymentProcess, {
            payment_method_id: paymentMethodId,
            package: packageId
        });
        if ((response.status === 200 || response.status === 201) && response.data.success) {
            const { new_token_balance } = response.data;
            store.dispatch(fetchBalanceSuccess(new_token_balance));
            // Update tokens in localStorage
            updateTokensInLocalStorage(new_token_balance);
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error processing payment:', error);
        throw error;
    }
};

export const saveGuideById = async (id: number) => {
    try {
        const res = await axiosInstance.post(endpoints.saveGuide(id));
        if (res.status === 200 || res.status === 201) {
            return res.data;
        }
        return null
    } catch (error) {
        console.error('Error creating guide:', error);
        throw error;
    }
};

export const unsaveGuideById = async (id: number) => {
    try {
        const res = await axiosInstance.delete(endpoints.saveGuide(id));
        if (res.status === 200 || res.status === 201) {
            return res.data;
        }
        return null
    } catch (error) {
        console.error('Error creating guide:', error);
        throw error;
    }
};

export const stats = async () => {
    try {
        const res = await axiosInstance.get(endpoints.stats);
        if (res.status === 200) {
            return res.data;
        }
        return null
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};

export const getCountries = async () => {
    try {
        const localCountries = localStorage.getItem(COUNTRIES);
        if (localCountries) {
            return JSON.parse(localCountries);
        }
        const res = await axiosInstance.get(endpoints.countries);
        if (res.status === 200) {
            localStorage.setItem(COUNTRIES, JSON.stringify(res.data));
            return res.data;
        }
        return null;
    } catch (error) {
        console.error('Error fetching countries:', error);
        throw error;
    }
};

export const getCities = async (countryCode: string, search?: string) => {
    try {
        const searchParam = search ? `?search=${encodeURIComponent(search)}` : '';
        const res = await axiosInstance.get(`${endpoints.cities(countryCode)}${searchParam}`);
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error('Error fetching cities:', error);
        throw error;
    }
};
